import { GET_REPORT, RESET_REPORT } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface ReportState extends BaseAsyncReducerState {
    report?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: ReportState  = {
    loading: false,
    error: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function reportReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_REPORT.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_REPORT.SUCCESS:
            return {
                ...state,
                report: payload,
                loading: false,
                error: false
            }
        case GET_REPORT.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_REPORT:
            return {
                ...state,
                report: null
            }
        default:
            return state
    }
}

export default reportReducer;
